// Runtime configuration read from CRA build-time env vars (REACT_APP_*).

/** Backend origin, e.g. http://127.0.0.1:8000. ws/wss is derived from this. */
export const API_URL: string = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000';

/** Optional bearer token appended as ?token= on the analysis WS URL. */
export const WS_TOKEN: string = process.env.REACT_APP_WS_TOKEN ?? '';

/** localStorage keys for the logged-in user's tokens (see auth/tokenStorage). */
export const AUTH_TOKEN_KEY = 'debug_auth-token';
export const REFRESH_TOKEN_KEY = 'debug_refresh-token';

/**
 * REST API base, e.g. http://127.0.0.1:8000/api/v1.
 * REST lives under <origin>/api/v1. We tolerate REACT_APP_API_URL given either
 * as a bare origin (http://host:8000) or already including /api
 * (https://host/api) — a trailing /api is stripped before appending /api/v1, so
 * it never doubles up.
 */
export const API_V1: string = API_URL.replace(/\/+$/, '').replace(/\/api$/, '') + '/api/v1';

/**
 * Build the analysis WebSocket URL from the API origin.
 * Mirrors the mobile buildAnalysisWsUrl: http(s)→ws(s), strip any path,
 * append /ws/analysis, and add ?token= when a token is supplied.
 *
 * The token is passed in by the caller (see ws/wsAuth.freshWsToken) rather than
 * read from a module constant here — the backend now gates /ws/analysis and the
 * primary credential is the logged-in user's JWT, which is resolved (and
 * refreshed) per-connect. WS_TOKEN remains a build-time fallback for machine use.
 */
export function buildAnalysisWsUrl(token?: string): string {
  const wsBase = API_URL.replace(/^https:\/\//, 'wss://').replace(/^http:\/\//, 'ws://');
  const match = wsBase.match(/^(wss?:\/\/[^/]+)/);
  const origin = match ? match[1] : wsBase;

  let url = `${origin}/ws/analysis`;
  if (token) url += `?token=${encodeURIComponent(token)}`;
  return url;
}
